import React from 'react';
import {Link,useLocation} from 'react-router-dom';
import {motion} from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const {FiHeart}=FiIcons;

function GlobalFavoritesButton() {
  const [selectedCount,setSelectedCount]=React.useState(0);
  const location=useLocation();

  React.useEffect(()=> {
    const updateCount=()=> {
      const stored=JSON.parse(localStorage.getItem('selectedPoses') || '[]');
      setSelectedCount(stored.length);
    };

    // Initial count
    updateCount();

    // Listen for storage changes (for cross-tab updates)
    const handleStorageChange=(e)=> {
      if (e.key==='selectedPoses') {
        updateCount();
      }
    };

    window.addEventListener('storage',handleStorageChange);

    // Custom event for same-tab updates
    window.addEventListener('favoritesUpdated',updateCount);

    return ()=> {
      window.removeEventListener('storage',handleStorageChange);
      window.removeEventListener('favoritesUpdated',updateCount);
    };
  },[]);

  // Don't show on the selection page itself
  if (location.pathname==='/selection') {
    return null;
  }

  return (
    <Link to="/selection">
      <motion.div
        whileHover={{scale: 1.1}}
        whileTap={{scale: 0.9}}
        className="fixed bottom-6 right-6 z-50"
      >
        <div className="relative">
          <div className="bg-white rounded-full shadow-lg border border-brand-bg-dark p-4 hover:shadow-xl transition-all duration-300">
            <SafeIcon icon={FiHeart} className="text-xl text-brand-accent" />
          </div>
          {selectedCount > 0 && (
            <motion.div
              initial={{scale: 0}}
              animate={{scale: 1}}
              className="absolute -top-2 -right-2 bg-brand-accent text-white rounded-full w-6 h-6 flex items-center justify-center text-xs font-bold shadow-lg"
            >
              {selectedCount}
            </motion.div>
          )}
        </div>
      </motion.div>
    </Link>
  );
}

export default GlobalFavoritesButton;